import React, {useEffect, useState} from "react";
import {useAuth0, withAuthenticationRequired} from "@auth0/auth0-react";
import Loading from "../components/Loading";
import UserService from "../services/UserService";
import Progress from "./Progress";

import { Parser } from 'html-to-react';
import {PageLoader} from "./PageLoader";
import Marquee from "react-fast-marquee";

export const TickerComponent = (props) => {

    const [state, setState] = useState({
        showResult: false,
        apiMessage: 'Tickers are loading ....',
        error: null,
    });

    const {
        getAccessTokenSilently,
        user
    } = useAuth0();

    const callApi = async () => {
        try {
            const token = await getAccessTokenSilently();
            UserService.getTicker(token, user, props.ticker.id).then(
                response => {
                    setState({
                        ...state,
                        showResult: true,
                        apiMessage: response.data,
                    });
                }
            );
        } catch (error) {
            setState({
                ...state,
                error: error.error,
            });
        }
    };

    useEffect(() => {

        // declare the data fetching function
        callApi();

    }, []);


    return (
        <div style={{
            width: '100%',
            maxWidth: '100%',
            overflow: 'hidden',
            position: 'relative'
        }}>
            {!state.showResult && (
                <div style={{
                    textAlign: 'center',
                    padding: '12px',
                    width: '100%'
                }}>
                    {/*<PageLoader></PageLoader>*/}
                </div>
            )}
            {state.showResult && (
                <div style={{
                    width: '100%',
                    maxWidth: '100%',
                    overflow: 'hidden'
                }}>
                    <div style={{
                        width: '100%',
                        maxWidth: '100%',
                        margin: '0',
                        padding: '8px 0',
                        border: 'none',
                        overflow: 'hidden'
                    }}>
                        <Marquee 
                            pauseOnClick={true} 
                            pauseOnHover={true} 
                            speed={20}
                            style={{
                                width: '100%',
                                maxWidth: '100%',
                                overflow: 'hidden'
                            }}
                        >
                            <div style={{
                                width: '100%',
                                maxWidth: '100%',
                                overflow: 'hidden',
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                <div style={{
                                    width: '100%',
                                    maxWidth: '100%',
                                    overflow: 'hidden',
                                    padding: '8px 12px',
                                    backgroundColor: '#f8f9fa',
                                    borderRadius: '4px',
                                    border: '1px solid #e9ecef',
                                    fontSize: '14px',
                                    lineHeight: '1.4',
                                    color: '#333',
                                    whiteSpace: 'nowrap'
                                }}>
                                    {Parser().parse(state.apiMessage.feed)}
                                </div>
                            </div>
                        </Marquee>
                    </div>
                </div>
            )}
        </div>
    );
};

export default withAuthenticationRequired(TickerComponent, {
    onRedirecting: () => <Loading/>,
});
